import { Controller } from 'react-hook-form';
import {
  Autocomplete,
  Checkbox,
  InputSize,
  InputText,
  SelectSize,
} from '@ui/src';
import InfoRow from '../../common/info-row';
import StepPartBlock from '../../common/step-part-block';
import { NewApplicationStatus } from '../../../../hoc/common/types';
import { CompanyAddressTypes } from './types';

import commonStyles from '../../common/styles.module.css';

const CompanyAddress = ({
  blockTitle,
  countryIdName,
  control,
  countries,
  status,
  isEditable,
  clearErrors,
  errors,
  cityName,
  postalCodeName,
  address1Name,
  address2Name,
  withCheckbox,
  checkboxName,
  fields,
}: CompanyAddressTypes) => (
  <StepPartBlock title={blockTitle}>
    <>
      {withCheckbox && checkboxName && (
        <div
          className={`${commonStyles.addressCheckboxWrapper} ${commonStyles.stepOneCheckboxWrapper} ${commonStyles.cddBlockContentCheckbox}`}
        >
          <Controller
            control={control}
            name={checkboxName}
            defaultValue={false}
            render={({ field: { onChange, value, name } }) => (
              <Checkbox
                name={name}
                type="checkbox"
                checked={value as boolean}
                onChange={(e) => onChange(e.target.checked)}
                title="Coincides with the registered address"
                labelClassName={commonStyles.addressCheckbox}
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
              />
            )}
          />
        </div>
      )}
      {(!withCheckbox ||
        (withCheckbox && checkboxName && !fields?.[checkboxName])) && (
        <>
          <InfoRow title="Country" id={countryIdName} lessPadding>
            <Controller
              control={control}
              name={countryIdName}
              defaultValue=""
              render={({ field: { onChange, value, name } }) => (
                <Autocomplete
                  name={name}
                  placeholder="Select country..."
                  list={countries}
                  value={value as string}
                  size={SelectSize.SMALL}
                  className={`${commonStyles.newApplicationAutocomplete} ${
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED
                      ? commonStyles.newApplicationAutocompleteDisabled
                      : ''
                  }`}
                  tabIndex={
                    !isEditable &&
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  onChange={(e) => {
                    onChange(e);
                    clearErrors([countryIdName]);
                  }}
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  error={errors?.[countryIdName]?.message}
                  fullWidth
                  borderless
                />
              )}
            />
          </InfoRow>
          <InfoRow title="City" id={cityName} lessPadding>
            <Controller
              control={control}
              name={cityName}
              defaultValue=""
              render={({ field: { onChange, value, name } }) => (
                <InputText
                  name={name}
                  placeholder="Enter city..."
                  value={value as string}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors([cityName]);
                  }}
                  size={InputSize.SMALL}
                  className="borderless"
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  tabIndex={
                    !isEditable &&
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  error={errors?.[cityName]?.message}
                />
              )}
            />
          </InfoRow>
          <InfoRow title="Postal code" id={postalCodeName} lessPadding>
            <Controller
              control={control}
              name={postalCodeName}
              defaultValue=""
              render={({ field: { onChange, value, name } }) => (
                <InputText
                  name={name}
                  placeholder="Enter postal code..."
                  value={value as string}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors([postalCodeName]);
                  }}
                  size={InputSize.SMALL}
                  className="borderless"
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  tabIndex={
                    !isEditable &&
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  error={errors?.[postalCodeName]?.message}
                />
              )}
            />
          </InfoRow>
          <InfoRow title="Address 1" id={address1Name} lessPadding>
            <Controller
              control={control}
              name={address1Name}
              defaultValue=""
              render={({ field: { onChange, value, name } }) => (
                <InputText
                  name={name}
                  placeholder="Enter address 1..."
                  value={value as string}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors([address1Name]);
                  }}
                  size={InputSize.SMALL}
                  className="borderless"
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  tabIndex={
                    !isEditable &&
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  error={errors?.[address1Name]?.message}
                />
              )}
            />
          </InfoRow>
          <InfoRow title="Address 2" id={address2Name} lessPadding>
            <Controller
              control={control}
              name={address2Name}
              defaultValue=""
              render={({ field: { onChange, value, name } }) => (
                <InputText
                  name={name}
                  placeholder="Enter address 2..."
                  value={value as string}
                  onChange={(e) => {
                    onChange(e);
                    clearErrors([address2Name]);
                  }}
                  size={InputSize.SMALL}
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  tabIndex={
                    !isEditable &&
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  className="borderless"
                  error={errors?.[address2Name]?.message}
                />
              )}
            />
          </InfoRow>
        </>
      )}
    </>
  </StepPartBlock>
);

export default CompanyAddress;
